<template>
  <div class="sidebar">
    <div class="list">
      <div v-for="sidebarItem in sidebarConfig" :key="sidebarItem.key">
        <div
          v-if="!sidebarItem.subroutes"
          :class="
            sidebarItem.linkedRoutes.includes($route.name)
              ? 'list-item-header-active'
              : 'list-item-header'
          "
          @click="!sidebarItem.linkedRoutes.includes($route.name) && changeRoute(sidebarItem)"
        >
          <div class="list-item-icon-container">
            <img class="list-item-icon" :src="getIcon(sidebarItem)" alt="Icon" />
          </div>
          <div class="list-item-title">
            {{ sidebarItem.label }}
          </div>
        </div>
        <div v-else class="list-item-subroutes-container">
          <div
            :class="
              sidebarItem.subroutes
                .map(subRoute => subRoute.linkedRoutes)
                .some(subroutesList => subroutesList.includes($route.name))
                ? 'active-subroutes-group'
                : 'list-item-subroutes-header'
            "
            @click="toggleGroup(sidebarItem)"
          >
            <div class="list-item-subroutes-header-container">
              <div class="list-item-icon-container">
                <img class="list-item-icon" :src="getIcon(sidebarItem)" alt="Icon" />
              </div>
              <div class="list-item-title">
                {{ sidebarItem.label }}
              </div>
            </div>
            <div class="list-item-group-icon-container">
              <img
                class="list-item-group-icon"
                :class="openSubroutes.includes(sidebarItem.key) && 'list-item-group-icon-open'"
                src="/assets/sidebar-icons/subroutes-group-icon.svg"
                alt="Group icon"
              />
            </div>
          </div>

          <div
            :class="
              openSubroutes.includes(sidebarItem.key)
                ? 'subroutes-container-active'
                : 'subroutes-container-hidden'
            "
          >
            <div
              v-for="subItem in sidebarItem.subroutes"
              :key="subItem.key"
              @click="!subItem.linkedRoutes.includes($route.name) && changeRoute(subItem)"
            >
              <div
                :class="
                  subItem.linkedRoutes.includes($route.name)
                    ? 'subitem-container-active'
                    : 'subitem-container'
                "
              >
                <div v-if="!subItem.requestCount" class="list-item-subtitle">
                  {{ subItem.label }}
                </div>
                <div v-else class="list-item-subtitle">
                  <v-badge v-model="requestCount">
                    <span v-if="requestCount" slot="badge">{{ requestCount }}</span>
                    <span>Pending requests</span>
                  </v-badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidebar',
  props: {
    sidebarConfig: {
      default: null,
      type: Array,
    },
    requestCount: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      openSubroutes: [],
    }
  },
  methods: {
    changeRoute(route) {
      this.$router.push(route.internalRoute)
    },
    getIcon(group) {
      return `/assets/sidebar-icons/${group.icon}.svg`
    },
    toggleGroup(group) {
      this.openSubroutes.includes(group.key)
        ? this.closeSubroutesGroup(group)
        : this.openSoubroutesGroup(group)
    },
    openSoubroutesGroup(group) {
      this.openSubroutes.push(group.key)
    },
    closeSubroutesGroup(group) {
      this.openSubroutes = this.openSubroutes.filter(groupKey => groupKey !== group.key)
    },
  },
}
</script>

<style scoped>
.sidebar {
  padding: 1rem 0.5rem;
  background-color: #f5f5f5;
  width: 22rem;
  border-radius: 0 0.75rem 0.75rem 0;
}

.list-item-header {
  height: 3rem;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
}

.list-item-header-active {
  height: 3rem;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  background-color: #0277bd;
  border-radius: 8px;
}

.list-item-icon-container {
  display: flex;
  height: fit-content;
}

.list-item-icon {
  height: 1.375rem;
  width: 1.375rem;
  margin-right: 0.75rem;
  filter: invert(51%) sepia(95%) saturate(0%) hue-rotate(227deg) brightness(98%) contrast(97%);
}

.list-item-group-icon-open {
  transform: rotate(180deg);
}

.list-item-header-active .list-item-icon {
  height: 1.375rem;
  width: 1.375rem;
  margin-right: 1rem;
  filter: invert(10%) sepia(72%) saturate(1812%) hue-rotate(180deg) brightness(7000%) contrast(830%);
}

.list-item-title {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  text-transform: uppercase;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #666666;
}

.list-item-header-active .list-item-title {
  color: white;
}

.list-item-header:hover {
  cursor: pointer;
}

.list-item-header:hover .list-item-title {
  color: #666666;
}

.list-item-header:hover .list-item-icon {
  filter: invert(41%) sepia(0%) saturate(15%) hue-rotate(236deg) brightness(93%) contrast(87%);
}

.list-item-subroutes-container {
  display: flex;
  flex-direction: column;
}

.list-item-subroutes-header {
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
}

.list-item-subroutes-header-container {
  display: flex;
  align-items: center;
}

.list-item-group-icon-container {
  display: flex;
}

.list-item-group-icon {
  height: 0.5rem;
  filter: invert(35%) sepia(95%) saturate(0%) hue-rotate(227deg) brightness(98%) contrast(97%);
}

.list-item-subroutes-header:hover {
  cursor: pointer;
}

.list-item-subroutes-header:hover .list-item-title {
  color: #666666;
}

.list-item-subroutes-header:hover .list-item-icon {
  filter: invert(41%) sepia(0%) saturate(15%) hue-rotate(236deg) brightness(93%) contrast(87%);
}

.list-item-subroutes-header:hover .list-item-group-icon {
  filter: invert(41%) sepia(0%) saturate(15%) hue-rotate(236deg) brightness(93%) contrast(87%);
}

.active-subroutes-group {
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
  background: #0277bd;
  border-radius: 0.5rem;
}

.active-subroutes-group:hover {
  cursor: pointer;
}

.active-subroutes-group .list-item-title {
  color: white;
}

.active-subroutes-group .list-item-icon {
  filter: invert(100%) sepia(20%) saturate(600%) hue-rotate(180deg) brightness(100%)
    contrast(15000%);
}

.active-subroutes-group .list-item-group-icon {
  filter: invert(100%) sepia(72%) saturate(1812%) hue-rotate(180deg) brightness(100%)
    contrast(100000%);
}

.subroutes-container-hidden {
  display: none;
}

.subroutes-container-active {
  display: flex;
  flex-direction: column;
}

.subitem-container {
  height: 2.5rem;
  padding-left: 3.12rem;
  display: flex;
  align-items: center;
}

.subitem-container-active {
  height: 2.5rem;
  padding-left: 3.12rem;
  display: flex;
  align-items: center;
  border-radius: 2rem;
}

.list-item-subtitle {
  font-family: 'Raleway', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #979797;
  width: 100%;
  display: flex;
  align-items: center;
  height: 2.1875rem;
  padding-left: 0.5rem;
  line-height: 120%;
  letter-spacing: -0.015em;
}

.subitem-container-active .list-item-subtitle {
  font-family: 'Raleway', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #0277bd;
  line-height: 120%;
  border-radius: 8px;
  background: #cee4f2;
  letter-spacing: -0.015em;
}

.subitem-container:hover {
  cursor: pointer;
}

.subitem-container:hover .list-item-subtitle {
  color: #666666;
}

@media only screen and (max-width: 800px) {
  .sidebar {
    width: 100%;
    border-radius: 2rem;
  }
}
</style>
